<div class="m-2">



  <div class="d-inline-block mt-3 mr-3">
    <mat-form-field appearance="outline" class="w-190p" color="accent">
      <input matInput (keyup.enter)="applyFilter(input)" #input placeholder="B2B/2025/00000">
      <button *ngIf="input.value" mat-button matSuffix mat-icon-button class="d-inline-block"
        (click)="applyFilter(input)">
        <mat-icon>search</mat-icon>
      </button>
      <button *ngIf="input.value" mat-button matSuffix mat-icon-button class="d-inline-block"
        (click)="input.value='';applyFilter(input)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    
  </div>

  <mat-form-field appearance="outline" class="mt-3" color="accent">
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
      <input readonly matStartDate formControlName="start">
      <input readonly matEndDate formControlName="end" (dateChange)="dateRangeChange($event)">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker" class="d-inline-block"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
     <button  class="button"
        (click)="getpdf()">
        <span id="pobierzpdf" [translation]="TranslationEnum.Translation">{{'pobierzpdf'|translate}}</span>
      </button>

  <div class="mw-100">

    <div class="loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
      <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
      <div *ngIf="isRateLimitReached" id="wystąpił_błąd_połączenia_proszę_odświeżyć_za_minutę"
        class="rate-limit-reached" [translation]="TranslationEnum.Translation">
        {{'wystąpił_błąd_połączenia_proszę_odświeżyć_za_minutę'|translate}}
        <!-- <app-tlumacz [id]="'Wystąpił błąd połączenia. Proszę odświeżyć za minutę.'" [typ]="'stale'" [tresci]="tresci">
        </app-tlumacz> -->
      </div>
    </div>

    <div class="w-100" *ngIf = "source.length > 0">
      <table mat-table matSort multiTemplateDataRows [(dataSource)]="dataSource" matSortActive="Departure_Date"
         matSortDirection="desc" class="w-100">


        <ng-container matColumnDef="select" class=" w-75p">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
            [checked]="Selection.hasValue() && isAllSelected()"
            [indeterminate]="Selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row"> 
          <mat-checkbox color="primary" *ngIf=" (row.ProformaFormat === undefinded && row.OrderStatusId !== 12)"
            (click)="$event.stopPropagation()" (change)="$event ? Selection.toggle(row) : null"
            [checked]="Selection.isSelected(row)">
          </mat-checkbox>
          <!-- 12 - weryfikacja zamówienia -->
        </td>
      </ng-container>

        <!-- ProformaFormat Column -->
        <ng-container matColumnDef="Route_Id">
          <th mat-header-cell *matHeaderCellDef  id="route_id"
            [translation]="TranslationEnum.Translation">
            {{'route_id'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Route_Id}} </td>
        </ng-container>
        <ng-container matColumnDef="Departure_Date">
          <th mat-header-cell *matHeaderCellDef  id="departure_date"
            [translation]="TranslationEnum.Translation">
            {{'departure_date'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Departure_Date | date:'yyyy-MM-dd'}} </td>
        </ng-container>
        
          <ng-container matColumnDef="Package_Number_Sum">
            <th mat-header-cell *matHeaderCellDef  id="package_number"
              [translation]="TranslationEnum.Translation">
              {{'package_number'|translate}}
              <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
            </th>
            <td mat-cell *matCellDef="let element"> {{getIlosc(element.Route_Id)}} </td>
          </ng-container>
        <ng-container matColumnDef="Delivery_Time">
          <th mat-header-cell *matHeaderCellDef  id="delivery_time"
            [translation]="TranslationEnum.Translation">
            {{'delivery_time'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Delivery_Time}} </td>
        </ng-container>
        <ng-container matColumnDef="Driver">
          <th mat-header-cell *matHeaderCellDef  id="driver"
            [translation]="TranslationEnum.Translation">
            {{'driver'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Driver}} </td>
        </ng-container>
        <ng-container matColumnDef="Drivers_Phone_Number">
          <th mat-header-cell *matHeaderCellDef  id="drivers_phone_number"
            [translation]="TranslationEnum.Translation">
            {{'drivers_phone_number'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Drivers_Phone_Number}} </td>
        </ng-container>
        <ng-container matColumnDef="Delivery_Address">
          <th mat-header-cell *matHeaderCellDef  id="delivery_address"
            [translation]="TranslationEnum.Translation">
            {{'delivery_address'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Delivery_Address}} </td>
        </ng-container>
        <ng-container matColumnDef="Delivery_City">
          <th mat-header-cell *matHeaderCellDef  id="delivery_city"
            [translation]="TranslationEnum.Translation">
            {{'delivery_city'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Delivery_City}} </td>
        </ng-container>
        <ng-container matColumnDef="Delivery_Country">
          <th mat-header-cell *matHeaderCellDef  id="delivery_country"
            [translation]="TranslationEnum.Translation">
            {{'delivery_country'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Delivery_Country}} </td>
        </ng-container>
        <ng-container matColumnDef="Sum_of_Weights">
          <th mat-header-cell *matHeaderCellDef  id="sum_of_weights"
            [translation]="TranslationEnum.Translation">
            {{'sum_of_weights'|translate}}
            <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </th>
          <td mat-cell *matCellDef="let element"> {{getWaga(element.Route_Id)}} </td>
        </ng-container>

        



        <ng-container matColumnDef="Expand">
          <th mat-header-cell *matHeaderCellDef [ngClass]="'minw-50p'"></th>
          <td mat-cell *matCellDef="let element" class="text-right" [ngClass]="'minw-50p'">
            <mat-icon color="primary" [hidden]="element.PurchasePermit === 1" class="animate">
              {{ expandedElement !== element ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
            <p id="dostępny" [translation]="TranslationEnum.Translation">
              {{'dostępny'|translate}}
              <!-- <app-tlumacz [id]="'Dostępny'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            <div class="element-detail" [ngClass]="element === expandedElement ? '' : 'h-0'"
              [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
              <table mat-table [dataSource]="getDetails(element.Route_Id)" class="mat-elevation-z8" class="expand_table">

                <!-- B2BId Column -->
                <ng-container matColumnDef="Order">
                  <th mat-header-cell *matHeaderCellDef id="order" [translation]="TranslationEnum.Translation">
                    {{'order'|translate}}
                    <!-- <app-tlumacz [id]="'B2Bid'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
                  </th>
                  <td mat-cell *matCellDef="let row"> {{row.Order}} </td>
                </ng-container>

                <!-- Product Column -->
                <ng-container matColumnDef="B2B_Number">
                  <th mat-header-cell *matHeaderCellDef id="b2b_number" [translation]="TranslationEnum.Translation">
                    {{'b2b_number'|translate}}
                    <!-- <app-tlumacz [id]="'Produkt'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
                  </th>
                  <td mat-cell *matCellDef="let row"> {{row.B2B_Number}} </td>
                </ng-container>

                
              <ng-container matColumnDef="Package_Number">
                <th mat-header-cell *matHeaderCellDef  id="package_number"
                  [translation]="TranslationEnum.Translation">
                  {{'package_number'|translate}}
                  <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
                </th>
                <td mat-cell *matCellDef="let element"> {{element.Package_Number}} </td>
              </ng-container>

            <ng-container matColumnDef="Sum_of_Weights">
              <th mat-header-cell *matHeaderCellDef  id="sum_of_weights"
                [translation]="TranslationEnum.Translation">
                {{'sum_of_weights'|translate}}
                <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
              </th>
              <td mat-cell *matCellDef="let element"> {{element.Sum_of_Weights}} </td>
            </ng-container>

            <ng-container matColumnDef="RefersTo">
              <th mat-header-cell *matHeaderCellDef  id="refersto"
                [translation]="TranslationEnum.Translation">
                {{'refersto'|translate}}
                <!-- <app-tlumacz [id]="'ProformaFormat'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
              </th>
              <td mat-cell *matCellDef="let element"> {{element.RefersTo}} </td>
            </ng-container>

                <tr mat-header-row *matHeaderRowDef="expandDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: expandDisplayedColumns;" class="child-row"></tr>
              </table>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="element-row"
          [class.expanded-row]="expandedElement === element"
          (click)="expandedElement = expandedElement === element ? null : element;">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row bg-white" *matNoDataRow>
          <td colspan="4" id="brak_danych_do_wyświetlenia" class="mat-cell" [translation]="TranslationEnum.Translation">
            {{'brak_danych_do_wyświetlenia'|translate}}
            <!-- <app-tlumacz [id]="'Brak danych do wyświetlenia'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz> -->
          </td>
        </tr>
      </table>
    </div>

  
  </div>
</div>
